<div class="pb-2">
  <div class="my-2 text-danger" *ngFor="let error of errors | keyvalue:keepOriginalOrder">
    <fa-icon icon="arrow-right"></fa-icon> {{error.value.message}}
  </div>
</div>
